import React, { memo } from "react";

import { Button } from "components/Buttons";
import { ButtonColorScheme, ButtonType } from "types/ui";

type Props = {
  id: string;
  index: number;
  text: string;
  onDelete: (id: string) => void;
  onEdit: (id: string) => void;
};

export const ExamNoteItem = memo(
  ({ id, index, text, onDelete, onEdit }: Props) => {
    const handleDelete = () => {
      onDelete(id);
    };

    const handleEdit = () => {
      onEdit(id);
    };
    return (
      <div className="w-full card flex justify-between pl-5 pr-7 py-2.5 rounded-[20px]">
        <div className="flex w-full items-start space-x-4">
          <div className="w-[26px] h-[26px] rounded-full bg-primary flex shrink-0 ">
            <strong className="text-lg text-white leading-[18px] font-semibold m-auto">
              {index + 1}
            </strong>
          </div>

          <p className="max-w-[90%] text-sm text-grayDark font-normal">
            {text}
          </p>
        </div>

        <div className="w-[140px] flex justify-center space-x-2 border-l border-border sm:flex-wrap">
          <Button
            title="Delete"
            onClick={handleDelete}
            type={ButtonType.text}
            classNames="text-[11px] bg-none"
            colorScheme={ButtonColorScheme.danger}
          />
          <Button
            title="Edit"
            onClick={handleEdit}
            type={ButtonType.small}
            classNames="self-center"
            colorScheme={ButtonColorScheme.primary}
          />
        </div>
      </div>
    );
  }
);
